<script lang="ts">
    export let primaryColor: string;
    let secondaryColor = "F7D34E";
</script>

<section
    class="bg-[#EFE7F1]/40 lg:mx-14 sm:mx-14 mx-7 my-20 xs:my-14 2xs:my-24 px-12 py-12 lg:py-8 rounded-2xl !mb-16 lg:!mb-28"
>
    <div
        class="w-full flex flex-col xl:flex-row justify-center xl:justify-between items-center gap-6 xl:gap-12"
    >
        <svg
            width="100"
            height="100"
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M28.7288 75.4805H57.4457V86.3428H28.7288V75.4805Z"
                fill={`#${secondaryColor}`}
            />
            <path
                d="M84.2379 36.1172C83.1592 36.1172 82.2848 36.9916 82.2848 38.0703V79.6995C82.2848 80.1653 82.2155 80.6151 82.0885 81.0403L53.5783 57.7723L76.8893 35.3692C77.667 34.6217 77.6916 33.3854 76.9442 32.6076C76.1967 31.8301 74.9604 31.8051 74.1827 32.5528L48.935 56.8172C47.3268 58.2555 45.2541 59.0473 43.0955 59.0473C40.9371 59.0473 38.8645 58.2555 37.2563 56.8172L5.72871 26.5178C6.52246 25.9024 7.51758 25.5348 8.59747 25.5348H77.5936C78.6723 25.5348 79.5467 24.6604 79.5467 23.5817C79.5467 22.503 78.6723 21.6285 77.5936 21.6285H8.59747C3.85684 21.6283 0 25.4848 0 30.2248V79.6995C0 84.4395 3.85684 88.296 8.59747 88.296H77.5936C82.3342 88.296 86.1911 84.4395 86.1911 79.6995V38.0703C86.1911 36.9916 85.3166 36.1172 84.2379 36.1172ZM4.10235 81.0395C3.97539 80.6147 3.90625 80.1651 3.90625 79.6995V30.2248C3.90625 30.2114 3.90723 30.1983 3.90723 30.1848L32.6024 57.7624L4.10235 81.0395ZM8.59747 84.3897C7.91446 84.3897 7.26563 84.2419 6.67969 83.9782L35.5102 60.4311C37.6928 62.0647 40.3459 62.9536 43.0955 62.9536C45.8403 62.9536 48.4887 62.0682 50.6692 60.4403L79.5108 83.9786C78.925 84.2419 78.2766 84.3897 77.5938 84.3897H8.59747Z"
                fill="#6B476F"
            />
            <path
                d="M55.2516 33.5433C55.2516 32.4646 54.3772 31.5902 53.2984 31.5902H32.8926C31.8139 31.5902 30.9395 32.4646 30.9395 33.5433C30.9395 34.622 31.8139 35.4965 32.8926 35.4965H53.2986C54.3772 35.4965 55.2516 34.622 55.2516 33.5433Z"
                fill={`${primaryColor}`}
            />
            <path
                d="M36.759 39.2019C35.6803 39.2019 34.8059 40.0763 34.8059 41.155C34.8059 42.2337 35.6803 43.1082 36.759 43.1082H49.4157C50.4944 43.1082 51.3688 42.2337 51.3688 41.155C51.3688 40.0763 50.4944 39.2019 49.4157 39.2019H36.759Z"
                fill={`${primaryColor}`}
            />
            <path
                d="M84.2379 43.2235C92.9431 43.2235 100 36.1677 100 27.4639C100 18.7601 92.9431 11.7043 84.2379 11.7043C75.5328 11.7043 68.4758 18.7601 68.4758 27.4639C68.4758 36.1677 75.5328 43.2235 84.2379 43.2235Z"
                fill={`#${secondaryColor}`}
            />
            <path
                d="M85.2652 34.2217C84.1865 34.2217 83.3121 33.3473 83.3121 32.2686V24.6122H83.2109C82.1322 24.6122 81.2578 23.7378 81.2578 22.6591C81.2578 21.5803 82.1322 20.7059 83.2109 20.7059H85.2652C86.3439 20.7059 87.2184 21.5803 87.2184 22.6591V32.2686C87.2184 33.3473 86.3439 34.2217 85.2652 34.2217Z"
                fill="#6B476F"
            />
        </svg>
        <h4
            class="text-xl font-bold mt-2 text-center"
            style="color: {primaryColor};"
        >
            Dapatkan berita Catch Me Up! langsung di inbox-mu setiap hari
            Senin-Jumat pukul 06.00 WIB
        </h4>
        <a
            href="/subscribe"
            style="background-color: {primaryColor};"
            data-sveltekit-reload
            class={`header-cta__link lsvr-button-custom text-white h-auto px-24`}
        >
            Mulai Berlangganan
        </a>
    </div>
</section>

<style>
    .lsvr-button-custom {
        border: 0;
        font-weight: 600;
        border-radius: 4px;
        padding: 10px 20px;
        font-size: 0.875em;
        white-space: nowrap;
        display: inline-block;
        text-decoration: none;
    }

    .lsvr-button-custom:hover {
        opacity: 0.8;
    }
</style>
